import { render, staticRenderFns } from "./BiodataDaftarDokumen.vue?vue&type=template&id=65768ec4&"
import script from "./BiodataDaftarDokumen.vue?vue&type=script&lang=js&"
export * from "./BiodataDaftarDokumen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports